import config from 'config'
const localURI = `https://localhost:44349/${config.apiGateway.DEFAULT_VERSION}`;
const defaultURI = `${config.apiGateway.URL}/${config.apiGateway.DEFAULT_VERSION}`;


// const selectedCompany = localStorage.getItem(`selectedCompanyId`);
export var apiUrls = {

    login: `${defaultURI}/login`,

    // GET APIs
    getMe: `${defaultURI}/Me`,
    getRoles: `${defaultURI}/Me/Roles`,
    getTheme: `${defaultURI}/Me/Theme`,
    getUserInfo: (id) => `${defaultURI}/Me/UserInfo/${id}`,
    getLogo: (companyId, shape, fallback) => {
        var url = `${defaultURI}/Company/${companyId}/Logo/${shape}`

        if (fallback !== undefined) {
            url += `?avatarFallback=${fallback}`;
        }

        return url;
    },
    getStatuses: (statusType) => `${defaultURI}/Status/List/${statusType}`,
    getEmployees: (companyId) => `${defaultURI}/Company/${companyId}/Employees`,
    getFiles: (companyId) => `${defaultURI}/Company/${companyId}/Files`,
    getVendorFiles: (companyId) => `${defaultURI}/Company/${companyId}/VendorFiles`,
    getDashboardCards: (companyId) => `${defaultURI}/Dashboard?companyId=${companyId}`,
    getDashboardItem: (companyId, type, period) => `${defaultURI}/Dashboard/Item/${companyId}/${type}/${period}`,
    getShowcaseDashboard: (companyId) => `${defaultURI}/Dashboard/Showcase?companyId=${companyId}`,
    getMessages: (companyId) => `${defaultURI}/Company/${companyId}/Messages`,
    getTimeSheets: (companyId, payPeriod) => {
         var url = `${defaultURI}/Company/${companyId}/TimeSheets`

         if (payPeriod !== undefined) {
            url += `?payPeriod=${payPeriod}`
        }
         return url;
    },
    getUserUploads: (companyId, type, typecode) => {
        var url = `${defaultURI}/Company/${companyId}/UserUploads/${type ? type : ""}`
        if(companyId == null || companyId.length <=0){
            url = `${defaultURI}/Me/Uploads/${type ? type : ""}`
        }
        if (typecode !== undefined) {
           url += `?uploadTypeCode=${typecode}`
       }
        return url;
    },
    getUserUploadsByUser: (companyId, type, typecode) => {
        var url = `${defaultURI}/Company/${companyId}/UserUploadsByUser/${type ? type : ""}`

        if (typecode !== undefined) {
            url += `?uploadTypeCode=${typecode}`
        }
        return url;
    },
    getUploadTypes: `${defaultURI}/File/UploadType`,
    getVendors: (companyId, type) => `${defaultURI}/Company/${companyId}/Vendors`,
    getFileErrors: (fileId) => `${defaultURI}/File/${fileId}/Errors`,
    getDownloadFileErrors: (fileId) => `${defaultURI}/File/${fileId}/DownloadErrors`,
    getInvoices: (companyId) => `${defaultURI}/Company/${companyId}/Invoices`,
    getEmpView: (employeeId) => `${defaultURI}/Employee/${employeeId}`,
    getEmpBenefitsDropdowns: (employeeId) => `${defaultURI}/Employee/${employeeId}/BenefitsDropdown`,
    getEmpEnrollments: (employeeId, planPeriod) => `${defaultURI}/Employee/${employeeId}/Enrollments/${planPeriod}`,
    getInvoicePaymentAmountDetails: (invoiceId) => `${defaultURI}/Invoice/${invoiceId}/Payments`,
    getInvoiceCreditDetails: (invoiceId) => `${defaultURI}/Invoice/${invoiceId}/Credits`,
    getInvoiceDisbursementDetails: (invoiceId) => `${defaultURI}/Invoice/${invoiceId}/Disbursements`,
    getCompanyList: `${defaultURI}/Me/Companies`,
    getContractCompanyList: `${defaultURI}/Me/ContractCompanies`,
    getAccounting: (companyId) => `${defaultURI}/Company/${companyId}/Accounting`,
    getFeedbackType: (portal) => `${defaultURI}/Feedback/Types/${portal}`,
    getHourbankDetails: (companyId, year) => `${defaultURI}/Hourbank/${companyId}/${year}`,
    getCompanyDropdowns: (companyId) => `${defaultURI}/Company/${companyId}/Dropdowns`,
    getOpenPayDatesDropdown: (companyId) => `${defaultURI}/Company/${companyId}/OpenPayDatesDropdown`,
    getCompanyDetails: (companyId) => `${defaultURI}/Company/${companyId}/Details`,
    getIsSubContractor: (companyId) => `${defaultURI}/Company/${companyId}/IsSubContractor`,
    getHWPayPeriods: (companyId) => `${defaultURI}/Company/${companyId}/HWPayPeriods`,
    getEmailTemplates: (companyId) => `${defaultURI}/Company/${companyId}/EmailTemplates`,
    getEmailTemplateByCategory: (companyId,caetgoryCode) => `${defaultURI}/Company/${companyId}/EmailTemplates/${caetgoryCode}`,
    getEmailAddresses: `${defaultURI}/Employer/EmailAddresses`,
    getGenericEmailTemplates: `${defaultURI}/Employer/GenericEmailTemplates`,
    getEmailTemplatePlaceholders: `${defaultURI}/Employer/EmailTemplatePlaceholders`,
    getEmailAttachments: (companyId, emailTemplateId) => `${defaultURI}/Company/${companyId}/EmailAttachments/${emailTemplateId}`,
    downloadEmailAttachments: (externalEmailFileId) => `${defaultURI}/File/${externalEmailFileId}/DownloadAttachment`,
    getEmployeeContractHours: (employeeId, startDate, endDate) => {
        return `${defaultURI}/Employee/${employeeId}/HourSummary?startDate=${startDate}&endDate=${endDate}`;

    },
    getEmployeeHWStatement: (employeeId, companyId, payDate, endDate) => {
        let endDateAttribute = '';
        if (endDate) {
            endDateAttribute = `&endDate=${endDate}`
        }

        return `${defaultURI}/Employee/${employeeId}/HWStatement?companyId=${companyId}&payDate=${payDate}${endDateAttribute}`;
    },
    getExcessAllocationTypes: (companyId) => `${defaultURI}/ExcessAllocation/${companyId}/Types`,
    getExcessAllocationDetails: (companyId, payoutTypeCode, year) => `${defaultURI}/ExcessAllocation/${companyId}/${payoutTypeCode}/${year}`,
    getHWStatementDetails: (companyId, startDate, endDate, lastName) => {
            var url = `${defaultURI}/Company/${companyId}/HWStatements/${startDate}`;

            var hasEndDate = endDate!==undefined;
            var hasLastName = lastName !==undefined && lastName != "";

            if (hasEndDate && hasLastName) {
                url += `?endDate=${endDate}&lastName=${lastName}`
            }
            else if (hasEndDate) {
                url += `?endDate=${endDate}`
            }
            else if (hasLastName) {
                url += `?lastName=${lastName}`
            }

            return url;
        },
    getQuarterlyDetails: (companyId, startDate, endDate, lastName) => `${defaultURI}/Company/${companyId}/HWStatements/${startDate}?endDate=${endDate}`,
    getYearlyDetails: (companyId,startDate, endDate, lastName) => `${defaultURI}/Company/${companyId}/HWStatements/${startDate}?endDate=${endDate}${lastName!==undefined?`&${lastName}`:""}`,
    getDropdown: (companyId) => `${defaultURI}/Company/${companyId}/Dropdowns`,
    downloadFile: (companyId, fileId) =>  {
        var company = '';
        if (companyId) {
            company = `/${companyId}`;
        }

        return `${defaultURI}/File/Download${company}/${fileId}`
    },
    downloadErrorFile: (companyId, fileId) =>  {
        var company = '';
        if (companyId) {
            company = `/${companyId}`;
        }

        return `${defaultURI}/File/Export${company}/${fileId}`
    },
    getReports: (companyId) => {
        var company = '';
        if (companyId) {
            company = `/${companyId}`;
        }

        return `${defaultURI}/Report/Queue${company}`
    },
    deleteReport: (companyId, reportQueueId) => `${defaultURI}/Report/Delete/${companyId}/${reportQueueId}`,
    downloadImage: (companyId, shape) => `${defaultURI}/File/DownloadImage/${companyId}/${shape}`,
    getRemittance: (companyId) => `${defaultURI}/Company/${companyId}/Remittance`,
    getCompliance: (companyId) => `${defaultURI}/Compliance/${companyId}`,
    getComplianceHours: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Hours`,
    getComplianceEnrollments: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Enrollments`,
    getRetroPeriods: (complianceId) => `${defaultURI}/Compliance/${complianceId}/RetroPeriods`,
    getInitialComplianceDetails: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Details`,
    getInitialComplianceStatus: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Status`,
    getComplianceReport: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Report`,
    getComplianceReports: (companyId) => `${defaultURI}/Compliance/${companyId}/Reports`,
    generateComplianceReport: (complianceId) => `${defaultURI}/Compliance/${complianceId}/GenerateReport`,
    getComplianceReportStatus: (companyId) => `${defaultURI}/Compliance/${companyId}/ReportStatus`,
    getAcknowledgements: (companyId) => `${defaultURI}/Company/${companyId}/Acknowledgements`,
    postAcknowledgement: (companyId, documentId, isAcked) => `${defaultURI}/Company/${companyId}/Acknowledgement/${documentId}/${isAcked}`,
    getBrdTimeline: (companyId) => `${defaultURI}/BRD/Timeline/${companyId}`,
    postBrdTimeline: (companyId) => `${defaultURI}/BRD/Timeline/${companyId}`,
    createBrdTimeline: (companyId) => `${defaultURI}/BRD/CreateTimeline/${companyId}`,
    deleteBrdTimeline: (companyId) => `${defaultURI}/BRD/DeleteTimeline/${companyId}`,

    // POST APIs
    setTheme: `${defaultURI}/Me/Theme`,
    postFeedbackForm: (companyId) => {
        var company = '';
        if (companyId) {
            company = `?companyId=${companyId}`;
        }

        return `${defaultURI}/Feedback${company}`;
    },
    addEmployee: () => `${defaultURI}/Employee`,
    terminateEmployee: (companyId, terminationDate, effectiveDate) => `${defaultURI}/Employee/Terminate?companyId=${companyId}&terminationDate=${terminationDate}&effectiveDate=${effectiveDate}`,
    rehireEmployee: (companyId, rehireDate, effectiveDate) => `${defaultURI}/Employee/Rehire?companyId=${companyId}&rehireDate=${rehireDate}&effectiveDate=${effectiveDate}`,
    sendCommunication: (companyId) => `${defaultURI}/Employee/SendCommunication/${companyId}`,
    employeePasswordReset: (companyId) => `${defaultURI}/Employee/ResetPassword?companyId=${companyId}`,
    uploadFile: (companyId, userUploadTypeId, payPeriod, isRetroPayPeriod, primeSubContractId) => {
        var url = `${defaultURI}/File/Upload/${companyId}/${userUploadTypeId}?`;

        if (payPeriod !== undefined && payPeriod !== null && payPeriod !== "") {
            url += `payPeriod=${payPeriod}&isRetroPayPeriod=${isRetroPayPeriod}`;
        }
        if (primeSubContractId !== undefined && primeSubContractId !== null) {
            url += `primeSubContractId=${primeSubContractId}`;
        }

        return url;
    },
    exportReport: (companyId, reportName) => `${defaultURI}/Report/Export/${companyId}/${reportName}`,
    uploadImage: (companyId) => `${defaultURI}/File/UploadImage/${companyId}`,
    exportEmployeeHWStatement: (fileName) => `${defaultURI}/Report/Export/${fileName}`,
    getCompanyHourTypes: (companyId) => `${defaultURI}/Company/${companyId}/HourTypes`,
    getTypeOfHours: () => `${defaultURI}/TypeOfHour`,
    postHourType: (companyId) => `${defaultURI}/HourType/${companyId}`,
    removeHourType: (companyId, hourTypeID) => `${defaultURI}/HourType/${companyId}/Remove/${hourTypeID}`,
    getCompanyContracts: (companyId) => `${defaultURI}/Company/${companyId}/Contracts`,
    getCompanyPrimeSubContracts: (companyId) => `${defaultURI}/Company/${companyId}/PrimeSubContracts`,
    postContract: (companyId) => `${defaultURI}/Contract/${companyId}`,
    postContractRate: (companyId) => `${defaultURI}/Contract/ContractRate/${companyId}`,
    postPrimeSubContract: (companyId) => `${defaultURI}/PrimeSubContract/${companyId}`,
    assignPrimeSubContract: (companyId) => `${defaultURI}/PrimeSubContract/${companyId}/AssignContract`,
    getAssignPrimeSubContract: (companyId, primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/AssignContract/${primeSubContractId}`,
    getPayFrequencies: () => `${defaultURI}/PayFrequency`,
    getPayPeriods: (companyId) => `${defaultURI}/Company/${companyId}/PayPeriods`,
    getBenefitPayPeriods: (companyId) => `${defaultURI}/Company/${companyId}/BenefitPaypPeriods`,    
    postWorkPayPeriods: (companyId) => `${defaultURI}/PayPeriod/${companyId}/Hour`,
    postWorkPayPeriodUpdate: (companyId,payPeriodId) => `${defaultURI}/PayPeriod/${companyId}/Hour/${payPeriodId}`,
    deletePayPeriod: (companyId,payPeriodId) => `${defaultURI}/PayPeriod/${companyId}/${payPeriodId}`,
    postEmailTemplate: (companyId) => `${defaultURI}/Company/${companyId}/EmailTemplate`,
    removeEmailTemplate: (companyId, emailTemplateId) => `${defaultURI}/Company/${companyId}/RemoveEmailTemplate/${emailTemplateId}`,
    postEmailAttachment: (companyId, emailTemplateId) => `${defaultURI}/File/UploadAttachment/${companyId}/${emailTemplateId}`,
    deleteEmailAttachment: (companyId, emailAttachmentId) => `${defaultURI}/File/DeleteAttachment/${companyId}/${emailAttachmentId}`,
    sendTestEmail: (companyId, emailTemplateId) => `${defaultURI}/Employer/SendTestEmail/${companyId}/${emailTemplateId}`,
    sendEmail: (companyId, emailTemplateId) => `${defaultURI}/Employer/SendEmail/${companyId}/${emailTemplateId}`,
    getPlans: (companyId) => `${defaultURI}/Company/${companyId}/Plans`,
    getPlanBenefits: (companyId,planPeriodId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/Benefits`,
    getPlanBenefitCoverageRates: (companyId,planPeriodId,benefitId,benefitCoverageId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/Benefit/${benefitId}/BenefitCoverage/${benefitCoverageId}`,
    getPlanDocuments: (companyId, planPeriodId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/Documents`,
    getPlanDocument: (companyId, documentId) => `${defaultURI}/Company/${companyId}/Document/${documentId}`,
    downloadPlanDocument: (companyId, documentId) => `${defaultURI}/Company/${companyId}/DownloadDocument/${documentId}`,
    downloadAllPlanDocuments: (companyId, planPeriodId) => `${defaultURI}/Company/${companyId}/DownloadAll/${planPeriodId}`,
    downloadSelectedPlanDocuments: (companyId, planPeriodId) => `${defaultURI}/Company/${companyId}/DownloadSelected/${planPeriodId}`,
    getLogIQmindReport: (companyId) => `${defaultURI}/File/LogIQmindReport/${companyId}`,
    downloadLogIQmindReport: (companyId) => `${defaultURI}/File/LogIQmindReport/${companyId}/Download`,
    getVariableTypes: (variableType) => `${defaultURI}/VariableType/${variableType}`,
    getPlanBenefitDetail: (companyId,planPeriodId,benefitId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/Benefit/${benefitId}`,
    getComplianceEmployees: (companyId) => `${defaultURI}/Company/${companyId}/ComplianceEmployees`,
    getNotInComplianceEmployees: (companyId) => `${defaultURI}/Company/${companyId}/NotInComplianceEmployees`,
    getTerminatedEmployees: (companyId) => `${defaultURI}/Company/${companyId}/TerminatedEmployees`,
    getCensus: (companyId) => `${defaultURI}/Company/${companyId}/Census`,
    getInsuredDetail: (insuredId) => `${defaultURI}/Insured/${insuredId}`,
    getNextOpenPayperiod: (companyId) => `${defaultURI}/Company/${companyId}/NextOpenHWBenefitDate`,
    getStates: () => `${defaultURI}/ListOfValues/States`,
    getCountries: () => `${defaultURI}/ListOfValues/Countries`,
    getEmploymentStatuses: ()=>`${defaultURI}/ListOfValues/EmploymentStatuses`,
    getEmployeeGroups: (companyId) => `${defaultURI}/Company/${companyId}/EmployeeGroups`,
    getMaritalStatuses: ()=>`${defaultURI}/ListOfValues/MaritalStatuses`,
    getGenders: ()=>`${defaultURI}/ListOfValues/Genders`,
    getEnrollments: (insuredId,effectiveDate) => `${defaultURI}/Employee/${insuredId}/InsuredEnrollments/${effectiveDate}`,
    getAvailableEnrollments: (companyId,insuredId,benefitPackageId,effectiveDate) => `${defaultURI}/Employee/${companyId}/${insuredId}/InsuredAvailableBenefits/${benefitPackageId}/${effectiveDate}`,
    getNewAvailableEnrollments: (companyId,benefitPackageId,effectiveDate) => `${defaultURI}/Employee/${companyId}/AvailableBenefits/${benefitPackageId}/${effectiveDate}`,
    getCostShares: (benefitPackageId, benefitId) => `${defaultURI}/CostShare/ByBenefitPackage/${benefitPackageId}/ByBenefit/${benefitId}`,
    postCensusManagement: (companyId) => `${defaultURI}/CensusManagement/${companyId}`,
    parseCensusManagement: (companyId) => `${defaultURI}/CensusManagement/${companyId}/Parse`,
    getPriorCensusManagement: (companyId) => `${defaultURI}/CensusManagement/${companyId}/PreviousData`,
    getPriorCensusManagementDetail: (companyId,censusManagementId) => `${defaultURI}/CensusManagement/${companyId}/${censusManagementId}`,
    getPriorCensusManagementDetailFiles: (companyId,censusManagementId) => `${defaultURI}/CensusManagement/${companyId}/${censusManagementId}/Files`,
    postPlanBenefitDetail: (companyId,planPeriodId,benefitId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/Benefit/${benefitId}`,
    getCoverageLevels: () => `${defaultURI}/CoverageLevel`,
    exportCostShares: (companyId,planPeriodId) => `${defaultURI}/Company/${companyId}/Plan/${planPeriodId}/RateTemplate`,
    getBenefitType: () => `${defaultURI}/BenefitType`,
    getCarrier: () => `${defaultURI}/Carrier`,
    saveCompliance: (companyId) => `${defaultURI}/Compliance/${companyId}`,
    saveComplianceStep: (companyId) => `${defaultURI}/Compliance/${companyId}/Step`,
    runInitialCompliance: (companyId, retroDate) => {
        return `${defaultURI}/Compliance/${companyId}/RunInitial${retroDate ? `?retroDate=${retroDate}` : ''}`
    },
    completeCompliance: (complianceId) => `${defaultURI}/Compliance/${complianceId}/Complete`,
    downloadInvoice: (invoiceId) => `${defaultURI}/Invoice/${invoiceId}/File`,
    getInvoiceUrl: (invoiceId) => `${defaultURI}/Invoice/${invoiceId}/Url`,
    downloadCreditNote: (creditNoteId) => `${defaultURI}/Invoice/${creditNoteId}/CreditNote`,
    getDownloadImportErrors: (fileId) => `${defaultURI}/File/${fileId}/DownloadImportErrors`,
    getEmployeesWithEnrollmentInfo: (companyId,benefitDate,benefitType) => `${defaultURI}/Company/${companyId}/EmployeesWithEnrollmentInfo/${benefitType}/${benefitDate}`,
    postTableDownloadAudit: () => `${defaultURI}/Log/TableDownload`,
    exportEmployeesWithEnrollmentInfo: (companyId,benefitDate,benefitType) => `${defaultURI}/Company/${companyId}/ExportEmployeesWithEnrollmentInfo/${benefitType}/${benefitDate}`,
    getEnrollmentHistory: (insuredId,benefitTypeId,planPeriodId) => {
        return `${defaultURI}/Employee/GetEnrollments?insuredId=${insuredId}&benefitTypeId=${benefitTypeId}&planPeriodId=${planPeriodId}`;
    },
    getLogIQmindReports: (companyId) => `${defaultURI}/Company/${companyId}/LogIQmindReports`,
    postContractUser: (companyId) => `${defaultURI}/Contract/${companyId}/ContractUser`,
    getContractUsers: (companyId) => `${defaultURI}/Contract/${companyId}/ContractUsers`,
    getPrimeSubContractUsers: (companyId) => `${defaultURI}/PrimeSubContract/${companyId}/ContractUsers`,
    getUserContracts: (companyId,userId) => `${defaultURI}/Contract/${companyId}/UserToContracts/${userId}`,
    postUserToContracts: (companyId,userId) => `${defaultURI}/Contract/${companyId}/UserToContracts/${userId}`,
    grantPrimeSubContractUsers: (companyId, userId, primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/ContractUsers/${userId}/Grant/${primeSubContractId}`,
    removePrimeSubContractUsers: (companyId, userId, primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/ContractUsers/${userId}/Remove/${primeSubContractId}`,
    getPrimeSubContractHistory: (companyId,primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/History/${primeSubContractId}`,
    postEnrollment:(employeeId) => `${defaultURI}/Employee/${employeeId}/Enrollment`,
    postEmployee:(employeeId) => `${defaultURI}/Employee/Employment`,
    postInsured:(insuredId) => `${defaultURI}/Insured/${insuredId}`,
}

export var ap3ApiUrls = {
    getDashboard: `${defaultURI}/ap3/Dashboard`,
}

export var primeApiUrls = {
    getDashboard:(beginDate,endDate) => `${defaultURI}/prime/Dashboard/${beginDate}/${endDate}`,
    getContractor:(companyId) => `${defaultURI}/prime/Dashboard/${companyId}`,
    getFailedContractors:(filter) => `${defaultURI}/prime/FailedContractors/${filter}`,
    postCompliance:(companyId,userUploadId) => `${defaultURI}/PrimeSubContract/${companyId}/AddCopmliance/${userUploadId??""}`,
    rejectUpload:(companyId,userUploadId,primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/Reject/${userUploadId}/${primeSubContractId??""}`,
    getContractorDashboard:(companyId,beginDate,endDate) => `${defaultURI}/prime/Contractor/${companyId}/${beginDate}/${endDate}`,
    // approveUpload:(companyId,userUploadId,primeSubContractId) => `${defaultURI}/PrimeSubContract/${companyId}/Approve/${userUploadId}/${primeSubContractId??""}`,
}

export var employeeApiUrls = {
    getInsuredId: `${defaultURI}/Me/InsuredId`,
    getDashboardData: (insuredId) => `${defaultURI}/Insured/${insuredId}/Dashboard`,
    getDashboardDataHwBenefit: (insuredId, hwBenefitDate) => `${defaultURI}/Insured/${insuredId}/Dashboard/${hwBenefitDate}`,
    //getMyMessages: `${defaultURI}/Me/Messages`,
    getMyMessages: `${defaultURI}/Me/Messages`,
    getTimeSheetPayPeriods: `${defaultURI}/Me/TimeSheetPayPeriods`,
    getTimeSheets: `${defaultURI}/Me/TimeSheets`,
    getPayoutTypes: `${defaultURI}/Me/PayoutTypes`,
    getPayouts: (payoutType, fromHwBenefitDate, toHwBenefitDate  ) => `${defaultURI}/Me/Payout/${payoutType}/${fromHwBenefitDate}/${toHwBenefitDate}`,
    getHourbankTypes: `${defaultURI}/Me/HourbankTypes`,
    getHourbankBalance:  (hourbankType, hwBenefitDate ) => `${defaultURI}/Me/Hourbank/${hourbankType}/${hwBenefitDate}`,
    getHourbanks:  (hourbankType, fromHwBenefitDate, toHwBenefitDate  ) => `${defaultURI}/Me/Hourbank/${hourbankType}/${fromHwBenefitDate}/${toHwBenefitDate}`,
    getBenefitPeriods: (insuredId) => `${defaultURI}/Insured/${insuredId}/BenefitPeriods`,
    getBenefits: (insuredId, benefitPeriod) => `${defaultURI}/Insured/${insuredId}/Benefits?payDate=${benefitPeriod}`,
    getHWPayPeriods: `${defaultURI}/Me/HWPayPeriods`,
    getHWStatement: (payDate, endDate) => {
        let endDateAttribute = '';
        if (endDate) {
            endDateAttribute = `&endDate=${endDate}`
        }

        return `${defaultURI}/Me/HWStatement?payDate=${payDate}${endDateAttribute}`;
    },
    getFiles: `${defaultURI}/Me/Files`,

    exportReport: (fileName) => `${defaultURI}/Report/Export/${fileName}`,
}

export var brokerApiUrls = {
    getBrokerCompanies: `${defaultURI}/Broker/Companies`,
    getBrokerLogIQmindReports:  `${defaultURI}/Broker/LogiqMindReports`,
    submitLogIQmindRequest: `${defaultURI}/Broker/Request`,
}

export var contractorApiUrls = {
    getContracts: () => `${defaultURI}/Contract/Contractor/Contracts`,
    getContract: (contractId) => `${defaultURI}/Contract/Contractor/ViewContract/${contractId}`,
    getPendingContractChanges: (contractId) => `${defaultURI}/Contract/Contractor/PendingChanges/${contractId}`,
    getAllContractChanges: (contractId) => `${defaultURI}/Contract/Contractor/AllChanges/${contractId}`,
    getContractChanges: (contractId, showAllChanges) => `${defaultURI}/Contract/Contractor/GetContractChanges/${contractId}/${showAllChanges}`,
    getContractRateChanges: (contractId, showAllChanges) => `${defaultURI}/Contract/Contractor/GetContractRateChanges/${contractId}/${showAllChanges}`,
    getContractCodeChanges: (contractId, showAllChanges) => `${defaultURI}/Contract/Contractor/GetContractCodeChanges/${contractId}/${showAllChanges}`,
    getAcknowledgeChanges: (contractId) => `${defaultURI}/Contract/Contractor/AcknowledgeChanges/${contractId}`,
    postAcknowledgeChanges: (contractId) => `${defaultURI}/Contract/Contractor/AcknowledgeChanges/${contractId}`,
    getDashboard:(beginDate,endDate) => `${defaultURI}/contractor/Dashboard/${beginDate}/${endDate}`,
}
